import db from './db'

export const getUserTypeOrThrow = user => {
  return db.users.findById(user.uid).then(userData => {
    if (userData.type) return userData.type
    else throw Error('Authenticated user does not have an assigned type.')
  })
}

export const getUserTeam = user => {
  return db.users.findById(user.uid).then(userData => {
    return userData.team
      ? userData.team.get().then(team => ({ id: team.id, ...team.data() }))
      : null
  })
}



// WEBPACK FOOTER //
// ./src/helpers/user.js